import STKAnimated from "@/components/common/animated";
import { MutableRefObject } from "react";
import SimpleReactValidator from "simple-react-validator";
import ContactPeople from "../components/contactPeople";
import { PageContentField } from "@/providers/content-provider";
import { viewHeadings } from "../will-editor";
type Props = {
    simpleValidator: MutableRefObject<SimpleReactValidator>,
    addNotification: (message: any) => void
}

const WillEditorView2 = ( props: Props ) => {


    return(
        <STKAnimated key={2} type="down-to-up">
            <h4>1. {viewHeadings[1]}</h4>
            <PageContentField section={'view-2'} index={0} />
            <ContactPeople name="contactPeople" simpleValidator={props.simpleValidator} addNotification={props.addNotification} />
        </STKAnimated>
    );

}

export default WillEditorView2;
